module.exports = __webpack_public_path__ + "img/wulingshima.141ace7d.png";